import { LogLevel } from '@azure/msal-browser'

const isValidEnv = (v) => typeof v === 'string' && v.trim() !== '' && v !== 'undefined' && v !== 'null'

export const isAzureEnabled =
  isValidEnv(process.env.REACT_APP_AZURE_CLIENT_ID) &&
  isValidEnv(process.env.REACT_APP_AZURE_TENANT_ID) &&
  isValidEnv(process.env.REACT_APP_AZURE_REDIRECT_URI) &&
  isValidEnv(process.env.REACT_APP_AZURE_CUSTOM_SCOPE)

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID}`,
    redirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
    postLogoutRedirectUri: process.env.REACT_APP_AZURE_REDIRECT_URI,
    navigateToLoginRequestUrl: false
  },
  system: {
    allowPlatformBroker: false, // Disables WAM Broker
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message)
            return
          case LogLevel.Info:
            console.info(message)
            return
          case LogLevel.Verbose:
            console.debug(message)
            return
          case LogLevel.Warning:
            console.warn(message)
            return
          default:
            return
        }
      }
    },
    logLevel: LogLevel.Verbose
  }
}

export const loginRequest = isAzureEnabled ? { scopes: [process.env.REACT_APP_AZURE_CUSTOM_SCOPE] } : null
